import React, { useEffect, useState } from 'react';

const KaKaoMap3 = () => {
  const [mapHeight, setMapHeight] = useState('670px');

  useEffect(() => {
    // ✅ 모바일 디바이스일 경우 높이 조정
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    setMapHeight(isMobile ? '440px' : '670px');

    const { kakao } = window || {};
    if (!kakao || !kakao.maps) return;

    const container = document.getElementById('map-hongseong');
    if (!container) return;

    const centerPosition = new kakao.maps.LatLng(36.5823385631135, 126.664273052049);

    const map = new kakao.maps.Map(container, {
      center: centerPosition,
      level: 3,
    });

    const markerImage = new kakao.maps.MarkerImage('/kakao_icon.png', new kakao.maps.Size(50, 50), {
      offset: new kakao.maps.Point(37, 73),
    });

    const marker = new kakao.maps.Marker({
      position: centerPosition,
      image: markerImage,
    });

    marker.setMap(map);
  }, []);

  return (
    <div>
      <div
        id="map-hongseong"
        className="map"
        style={{
          width: '100%',
          height: mapHeight,
        }}
      />
    </div>
  );
};

export default KaKaoMap3;
